import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import Drawer from 'components/Shared/Drawers';

import SearchableContactList from 'components/Shared/Contacts/SearchableContactList';
import { CONTACT_STATUS } from 'const/user';
import SimpleSkeleton from 'components/Shared/Contacts/SimpleSkeleton';
import CategoryTitle from 'components/Shared/Layout/CategoryTitle';
import Icon from 'components/Shared/Common/Icon';

const formatMessages = intl => () => ({
    drawerTitle: intl.formatMessage({
        id: 'drawer.createUnicastFeed.title',
        defaultMessage: 'Discussions privées'
    }),
    placeholderSubtitle: intl.formatMessage({
        id: 'drawer.createUnicastFeed.fallbackMessage.subtitle',
        defaultMessage: 'N\'hésitez pas à ajouter de nouvelles relations.'
    }),
    contactFallbackMessage: intl.formatMessage({
        id: 'rightColumn.contacts.fallbackMessage',
        defaultMessage: 'Votre liste de contact est vide.'
    }),
    searchFallBackMessage: intl.formatMessage({
        id: 'rightColumn.contacts.searchFallBackMessage',
        defaultMessage: 'Aucun résultat ne correspond à votre recherche.'
    }),
    placeholder: intl.formatMessage({
        id: 'rightColumn.contacts.search.placeholder',
        defaultMessage: 'Rechercher un contact'
    })
});

const DrawerCreateGroup = (props) => {
    const {
        intl,
        onClose,
        openSearchDrawer
    } = props;
    const i18n = formatMessages(intl)();

    const handleOpenDrawer = useCallback(() => {
        onClose();
        openSearchDrawer();
    }, [onClose, openSearchDrawer]);

    return (
        <Drawer
            isOpen
            onClose={onClose}
            title={(
                <CategoryTitle
                    label={i18n.drawerTitle}
                    icon={<Icon size="xl" iconName="MessageCircle" />}
                />
            )}
            placement="left"
        >
            <SearchableContactList
                openSearchDrawer={handleOpenDrawer}
                contactStatus={CONTACT_STATUS.ACCEPTED}
                SkeletonComponent={SimpleSkeleton}
            />
        </Drawer>
    );
}

DrawerCreateGroup.propTypes = {
    intl: PropTypes.any.isRequired,
    onClose: PropTypes.func.isRequired,
    openSearchDrawer: PropTypes.func.isRequired
};

export default injectIntl(DrawerCreateGroup);
